import {
  getData,
  postData,
  getPromise
} from './api-base.service'

export const getParentPageData = (keyword, sortList) => {
  let data = {
    Keyword: keyword,
    SortList: sortList
  };
  var result = postData('/Parent/GetParentPageData', data);
  return result;
}

export const saveParent = (data) => {
  let result = postData('/Parent/SaveParent', data);
  return result;
}



// WEBPACK FOOTER //
// ./src/service/parent.service.js